export const ACCESS_MODULES_GET = 'ACCESS_MODULES_GET'
